export default __webpack_public_path__ + "static/media/6.563554c0.jpg";